import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { LinkButton } from "../../../globals/components/button";
import { motion, AnimatePresence } from "framer-motion";


const PurpleBar = styled.div`
  justify-content: center;
  background: #683d8c;
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 0%;
`

const Button = styled.button`
    font-size: 2em;
    background: rgb(234, 146, 19);
    background: linear-gradient(
        0deg,
        rgba(234, 146, 19, 1) 0%,
        rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    color: #fff;
    user-select: none;
    padding: 0.25em 2.5em;
    margin: 1em 0;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin: 0;
    }
`;






export default (props) => {

  const [showPurple, setShowPurple] = useState(true);

  const variants = {
    show: {
      bottom: "0%",
      transition: {
        type: "spring",
        bounce: 0,
        duration: 0,
      }
    },
    hide: {
      bottom: "-100%",
      transition: {
        type: "spring",
        bounce: 0,
        duration: 1.5
      }
    }
  };


  function ShowPurpleBar(value){
    setShowPurple(value);
  }

  useEffect(() => {
    console.log("Show Bar: " + props.showBar)
    if (props.showBar == true){
      ShowPurpleBar(true);
    }
  }, [props.showBar])
  

  return (
    <AnimatePresence>
  
      <PurpleBar as={motion.div} variants={variants} style={props.style} animate={showPurple ? "show": "hide"}>
        <Button onClick={() => {
              ShowPurpleBar(false);
              props.setShowShop(true);
            }}style={{width: "30%", height: "100px"}}>
                  Shop
              </Button>
      </PurpleBar>
  </AnimatePresence>
  );
};
